import { forwardRef } from "react";
import { AspectRatioGuideOverlay } from "../AspectRatioGuideOverlay";

/**
 * Wrapper div positioned by the VideoSurface overlay-sizing effect to match
 * the displayed video area (accounting for letterboxing). Hosts the
 * aspect-ratio guide overlay so the guide aligns to the actual frame, not
 * the player container.
 */
export const ExactVideoOverlay = forwardRef<HTMLDivElement>((_props, ref) => {
  return (
    <div ref={ref} className="pointer-events-none absolute top-0 left-0">
      <AspectRatioGuideOverlay />
    </div>
  );
});
